import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment/moment';
import { datePickerAppDate } from '../../../../constants/constants';
import { MISReportDateFormat } from '../../../../constants/constants';



const today = moment().format(datePickerAppDate)
var formattedDateToday = moment(today, datePickerAppDate).format(MISReportDateFormat);

const toDateFormatted = formattedDateToday;
console.log(toDateFormatted);
//const fromDateCopy = new Date(today);
//fromDateCopy.setDate(today.getDate() - 90);
const fromDateFormatted = moment().subtract(3, 'month').format(datePickerAppDate);
var formattedDateFrom = moment(fromDateFormatted, datePickerAppDate).format(MISReportDateFormat);

const fromDate = formattedDateFrom;
const NavigateDataSlice = createSlice({
    name: 'navigate',
    initialState: {
        navigationPath: 'dashboard',
        navigationSubPath: 'All',
        data: {},
        payload: {},
        searchFilterData: {
            "status": "All",
            "fromDate": fromDate,
            "toDate": toDateFormatted,
            "feedbackCode": "",
            "feedbackType": { "id": "" },
            "feedbackSource": { "id": "" },
            "area": { "id": "" },
            "subArea": { "id": "" },
            "user": { "id": "", "orgName": "", "email": "", "phone": "", "mobile": "" },
            "attributeList": [{ "attributeType": "", "departmentAttributeId": "", "attributeId": "", "mandatory": "", "attributeVal": "" }]
        },
        filterData: {},
    },
    reducers: {
        setNavigationData: (state, action) => {
            const { navigationPath, navigationSubPath, data, filterData } = action.payload;
            state.navigationPath = navigationPath;
            state.navigationSubPath = navigationSubPath;
            state.data = data;
            state.filterData = filterData;
        },
        setPayloadData: (state, action) => {
            state.payload = action.payload;  // Update the payload in the state
        },
        setSearchFilterData: (state, action) => {
            state.searchFilterData = action.payload;  // Update the payload in the state
        },
    },
});

export const { setNavigationData, setPayloadData, setSearchFilterData } = NavigateDataSlice.actions;
export default NavigateDataSlice.reducer;
